module.exports = __webpack_public_path__ + "static/media/Teleconference-icon.48809b6c.svg";